import { getLocalizedProductText } from './utils/productHelpers'

const PhotoPreviewActions = ({
  photoPreview,
  onRemove,
  onSend,
  translations = {},
  language = 'EN',
}) => {
  return (
    <>
      <div className='upload-preview-wrap'>
        <img
          src={photoPreview}
          alt='Hair'
          className='upload-preview-img'
        />

        <button
          type='button'
          className='upload-remove-btn'
          onClick={onRemove}
        >
          ✕
        </button>
      </div>

      <button
        type='button'
        className='upload-send-btn'
        onClick={onSend}
      >
        {getLocalizedProductText({
          translations,
          language,
          keyPath: 'productFlow.photoUpload.sendPhoto',
          fallback: 'Send photo',
        })}{' '}
        →
      </button>
    </>
  )
}

export default PhotoPreviewActions